<template>
  <div>
    <a-card class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        formLayout="inline"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button type="primary" class="add-btn" @click="visibles = true" style="margin-right: 10px">
          批量评估
        </a-button>
        <a-button type="primary" class="add-btn" @click="visible = true">
          批量运行
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:action="{ tableRow }">
          <div>
            <a-button
              type="link"
              size="small"
              @click="handleDownload(tableRow)"
            >
              结果导出
            </a-button>
          </div>
        </template>
      </TableView>
    </a-card>

    <a-modal
      v-model="visible"
      destroyOnClose
      @ok="handleSubmit"
      title="批量运行"
      :maskClosable="false"
    >
      <a-form :form="modalForm" ref="modalForm">
        <a-form-item label="评分卡类型">
          <a-select v-decorator="$decorator('type', '请选择评分卡类型')">
            <a-select-option
              v-for="item in SCORE_CARD_SCHEMA"
              :key="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="财报时间">
          <a-date-picker
            v-decorator="$decorator('year', '请选择财报时间')"
            mode="year"
            :open="isOpen"
            format="YYYY"
            placeholder=""
            @openChange="handleOpenChange"
            @panelChange="handlePanelChange"
            @change="handleChange"
            class="year-date"
          />
        </a-form-item>

        <a-form-item label="业务类型">
          <a-select
            v-decorator="$decorator('business', '请选择业务类型')"
            @change="value => handleBusinessChange(value)"
            @focus="handleFocus"
          >
            <a-select-option
              v-for="item in businessList"
              :key="item.id"
              :disabled="item.disabled"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="业务模式">
          <a-select
            v-decorator="$decorator('model', '请选择业务模式')"
            @focus="handleModelFocus"
          >
            <a-select-option
              v-for="item in modelOptionList"
              :key="item.id"
              :disabled="item.disabled"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="信用主管">
          <a-select v-decorator="$decorator('creditManager', '请选择信用主管')">
            <a-select-option v-for="item in managerList" :key="item.username">
              {{ item.name }} - {{ item.username }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      v-model="visibles"
      destroyOnClose
      @ok="handleSubmits"
      title="批量评估"
      :maskClosable="false"
    >
      <a-form :form="modalForm" ref="modalForm">
        <a-form-item label="评分卡类型">
          <a-select v-decorator="$decorator('type', '请选择评分卡类型')">
            <a-select-option
              v-for="item in SCORE_CARD_SCHEMA"
              :key="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="财报时间">
          <a-date-picker
            v-decorator="$decorator('year', '请选择财报时间')"
            mode="year"
            :open="isOpen"
            format="YYYY"
            placeholder=""
            @openChange="handleOpenChange"
            @panelChange="handlePanelChange"
            @change="handleChange"
            class="year-date"
          />
        </a-form-item>
        <a-form-item label="模板下载">
          <a-button type="link" @click="handleTemplateDownload">
            点击下载
          </a-button>
        </a-form-item>
        <a-form-item label="附件上传">
          <a-upload
            :beforeUpload="handleBeforeUpload"
            :fileList="fileList"
            :remove="handleRemove"
            multiple
          >
            <a-button>
              <a-icon type="upload" />
              选取文件
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>

  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import {
  getTableData,
  getBusinessList,
  batchCalc,
  batchCalcCard,
  download,
  downloadCard,
  getRegionList,
  getManagerList,
  getFreezeBgList,
  getFreezeModelList,
  getRating,
  batchCalcList,
  batchCalcCardList,
  templateDownload
} from './api'
import { SCORE_CARD_SCHEMA } from 'utils/staticData'
import moment from 'moment'

export default {
  mixins: [mixin],
  components: {
    SearchView,
    TableView,
  },
  data() {
    return {
      tableLoading: true,
      visible: false,
      visibles: false,
      modalForm: this.$form.createForm(this),
      SCORE_CARD_SCHEMA,
      isOpen: false,
      businessList: [],
      modelOptionList: [], //业务模式列表
      managerList: [],
      syList: [], //冻结BG
      modelList: [], //业务模式冻结
      fileList: [],
    }
  },
  mounted() {
    this._getTableData()
    this._getBusinessList()
    this._getManagerList()
    this._getFreezeBgList()
    //评分卡类型增加自定义评分卡
    getRating().then(({ data }) => {
      var list = []
      data.forEach(item => {
        list.push({ value: item.id, label: item.cardName })
      })
      this.SCORE_CARD_SCHEMA = this.SCORE_CARD_SCHEMA.concat(list)
    })
  },
  methods: {
    //业务类型禁用
    handleFocus() {
      if (this.businessList) {
        this.businessList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.syList) {
        this.businessList.forEach(item => {
          this.syList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //一定要刷新组件！！！！！！！！！！！！
      }
    },
    //业务模式禁用
    handleModelFocus() {
      if (this.modelOptionList) {
        this.modelOptionList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.modelList) {
        this.modelOptionList.forEach(item => {
          this.modelList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //刷新组件
      }
    },

    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...this.searchForm,
        size: pageSize,
        current,
      }
      if (formData.date.length) {
        formData.startTime = formData.date[0]
        formData.endTime = formData.date[1]
      }
      delete formData.date
      delete formData.pageSize

      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      })
    },
    _getBusinessList() {
      getBusinessList().then(({ data }) => {
        this.businessList = data
      })
    },
    _getFreezeBgList() {
      getFreezeBgList().then(({ data }) => {
        this.syList = data
      })
    },
    _getFreezeModelList() {
      getFreezeModelList().then(({ data }) => {
        this.modelList = data
      })
    },
    _getManagerList() {
      getManagerList().then(({ data }) => {
        this.managerList = data
        data.unshift({
          name: 'All',
          username: 'All',
        })
      })
    },
    async handleBusinessChange(pid) {
      const type = 3
      const { data } = await getRegionList({ pid, type })
      this.modelOptionList = data
      data.unshift({
        id: 'All',
        name: 'All',
      })
      this.modalForm.setFieldsValue({ model: '' })
      this._getFreezeModelList()
    },
    // 提交
    handleSubmit() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          if (values.type < 10) {
            try {
              const { message } = await batchCalc({
                ...values,
                year: this.formatYear,
              })
              this.visible = false
              this.$notification.success({
                message: '提示',
                description: message,
              })
              this._getTableData()
            } catch (e) {
              // No processing
            }
          } else {
            try {
              const { message } = await batchCalcCard({
                //自定义评分卡
                ...values,
                year: this.formatYear,
              })
              this.visible = false
              this.$notification.success({
                message: '提示',
                description: message,
              })
              this._getTableData()
            } catch (e) {
              // No processing
            }
          }
        }
      })
    },
    // 上传客户List
    handleSubmits() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          const { fileList } = this
          if (values.type < 10) {
            try {
              const { message } = await batchCalcList({
                ...values,
                year: this.formatYear,
                file: fileList,
              })
              this.visibles = false
              this.$notification.success({
                message: '提示',
                description: message,
              })
              this._getTableData()
            } catch (e) {
              // No processing
            }
          } else {
            try {
              const { message } = await batchCalcCardList({
                //自定义评分卡
                ...values,
                year: this.formatYear,
                file: fileList,
              })
              this.visibles = false
              this.$notification.success({
                message: '提示',
                description: message,
              })
              this._getTableData()
            } catch (e) {
              // No processing
            }
          }
        }
      })
    },
    // 下载模板
    handleTemplateDownload() {
      templateDownload()
    },
    // 下载
    handleDownload(tableRow) {
      if (tableRow.cardId == null || tableRow.cardId == '') {
        download(tableRow.id)
      } else {
        downloadCard(tableRow.id)
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },

    handleOpenChange(status) {
      this.isOpen = status
    },
    handlePanelChange(value) {
      this.modalForm.setFieldsValue({ year: value })
      this.isOpen = false
      this.formatYear = moment(value).format('YYYY')
    },
    handleChange() {
      this.modalForm.setFieldsValue({ year: null })
      this.formatYear = ''
    },

    // 上传之前
    handleBeforeUpload(file) {
      this.fileList = [...this.fileList, file]
      this.fileList = this.fileList.slice(-1)
      return false
    },
    // 删除上传文件
    handleRemove(file) {
      const index = this.fileList.findIndex(item => item.uid === file.uid)
      this.remove(index)
    },
  },
}
</script>

<style scoped lang="less">
.year-date {
  width: 100%;
}
</style>
